import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import AppContext from '../../core/stores/AppContext';
import routes from '../../features/site/routes';

function Footer() {
	// useContext react hook is a simpler option, below is just for learning purpose
	return (
		<AppContext.Consumer>
			{context => (
				<footer>
					<Row className='footer-top row-ex'>
						<Col xs={12} md={6}>
							<h4 className='form-headline'>MORE FARMERS ARE SWITCHING TO ACHMEA</h4>
							<p className='form-body-text'>Agribusinesses around Australia are switching their farm insurance to <a href='https://www.achmea.com.au/farm-insurance/' className='form-body-text' target='_blank' rel='noopener noreferrer'>Achmea Farm Insurance</a>.</p>
							<a href='https://www.achmea.com.au/testimonials/' className='readmore form-body-text' target='_blank' rel='noopener noreferrer'>FIND OUT WHY <i className='bi bi-arrow-right-short' /></a>
						</Col>
						<Col xs={12} md={2} className='text-end'>
							<ul className='footer-nav-links'>
								<li><a href='https://www.achmea.com.au/why-achmea/' className='form-body-text' target='_blank' rel='noopener noreferrer'>WHY ACHMEA</a></li>
								<li><a href='https://www.achmea.com.au/about-us/' className='form-body-text' target='_blank' rel='noopener noreferrer'>ABOUT US</a></li>
								<li><a href='https://www.achmea.com.au/my-insurance/' className='form-body-text' target='_blank' rel='noopener noreferrer'>MY INSURANCE</a></li>
								<li><a href='https://www.achmea.com.au/farm-insurance/' className='form-body-text' target='_blank' rel='noopener noreferrer'>FARM INSURANCE</a></li>
								<li><a href='https://www.achmea.com.au/news/' className='form-body-text' target='_blank' rel='noopener noreferrer'>NEWS</a></li>
								<li><a href='https://www.achmea.com.au/publications/' className='form-body-text' target='_blank' rel='noopener noreferrer'>PUBLICATIONS</a></li>
							</ul>
						</Col>
						<Col xs={12} md={4} className='text-end'>
							<Button variant='outline' size='lg' className='mb-2 form-headline btn-hover-lightblue'><Link to={routes[1].path}>FARM INSURANCE QUOTE</Link></Button><br />
							<ul className='footer-contact-links'>
								<li>
									<a href='mailto:info@achmea.com.au' className='form-body-text' target='_blank' rel='noopener noreferrer'>INFO@ACHMEA.COM.AU <i className='bi bi-envelope-fill' /></a>
								</li>
								<li>
									<a href='tel:1800724214' className='form-body-text' target='_blank' rel='noopener noreferrer'>1800 724 214 <i className='bi bi-telephone' /></a>
								</li>
								<li>
									<a href='https://www.achmea.com.au/contact-us/' className='form-body-text' target='_blank' rel='noopener noreferrer'>ONLINE <i className='bi bi-chat-left-fill' /></a>
								</li>
							</ul>
						</Col>
					</Row>

					<div className='footer-main'>
						<Row className='row-ex'>
							<Col xs={12}>
								<p className='form-body-text'>Insurance issued by Achmea Schadeverzekeringen N.V. (Achmea) ABN 86 158 237 702 AFSL
									433984. The information in this document is general advice only and does not take
									into account your individual objectives, financial situation or needs (your personal
									circumstances). This means any advice may not be appropriate for your circumstances.
									Before using this information to decide whether to purchase the insurance policy,
									you will need to consider the appropriateness of any general information or advice
									we give you and how it relates to your specific situation to ensure the insurance
									cover meets your needs and the relevant Product Disclosure Statement and Target
									Market Determination (TMD) available from the 'Downloads' section of our website
									achmea.com.au/downloads. For feedback and complaints, visit
									achmea.com.au/complaints. To view Achmea Australia's privacy statement, visit
									achmea.com.au/privacy.</p>
							</Col>
						</Row>
						<Row className='row-ex'>
							<Col xs={12} md={8}>
								<ul className='footer-legal-links'>
									<li><a href='https://www.achmea.com.au/complaints/' className='form-body-text' target='_blank' rel='noopener noreferrer'>Feedback and Complaints</a></li>
									<li><a href='https://www.achmea.com.au/privacy/' className='form-body-text' target='_blank' rel='noopener noreferrer'>Privacy Statement</a></li>
									<li><a href='https://www.achmea.com.au/disclaimer/' className='form-body-text' target='_blank' rel='noopener noreferrer'>Online terms of use</a></li>
									<li><a href='https://www.achmea.com.au/legal-statement/' className='form-body-text' target='_blank' rel='noopener noreferrer'>Legal Statement</a></li>
								</ul>
							</Col>
							<Col xs={12} md={4}>
								<ul className='social-networks text-end'>
									<li>
										<a href='https://linkedin.com/company/achmea-australia' target='_blank' rel='noopener noreferrer'><i className='bi bi-linkedin' /></a>
									</li>
									<li>
										<a href='https://twitter.com/AchmeaA' target='_blank' rel='noopener noreferrer'><i className='bi bi-twitter' /></a>
									</li>
									<li>
										<a href='https://www.facebook.com/Achmea-Australia-2094205430627646/' target='_blank' rel='noopener noreferrer'><i className='bi bi-facebook' /></a>
									</li>
									<li>
										<span className='app-version'>v{context.stores.rootStore.version}</span>
									</li>
								</ul>
								<p className='text-end form-body-text'>
									This site is protected by reCAPTCHA and the Google{' '}
									<a href="https://policies.google.com/privacy" target='_blank' rel='noopener noreferrer'>Privacy Policy</a> and{' '}
									<a href="https://policies.google.com/terms" target='_blank' rel='noopener noreferrer'>Terms of Service</a> apply.
								</p>
							</Col>
						</Row>
					</div>
				</footer>
			)}
		</AppContext.Consumer>
	);
}

export default Footer;
